import React, { MouseEventHandler } from "react";

import { RekognitionResultItem } from "../../rekognition/listing/RekognitionResultItem";

interface VideoTimelineProps {
    videoDuration: number;
    setRewindTimestamp(timestamp: number): void;
    rekognitionItems: RekognitionResultItem[];
    isLoading: boolean;
    containerWidth: number;
    height: number;
    zIndex?: number;
}

export const VideoTimestampBar = (props: VideoTimelineProps): JSX.Element => {
    const { setRewindTimestamp, videoDuration, rekognitionItems, isLoading, containerWidth, height } = props;

    const onClick: MouseEventHandler<HTMLDivElement> = (event) => {
        const containerRect = event.currentTarget.getBoundingClientRect();
        const clickedX = event.clientX - containerRect.left;
        const percentageClicked = clickedX / containerWidth;

        setRewindTimestamp(percentageClicked * videoDuration);
    };

    const mapToRekognitionSegmentBar = (rekognitionItem: RekognitionResultItem) => {
        return (
            <div
                style={{
                    position: "absolute",
                    left: `${(rekognitionItem.startTimestamp / props.videoDuration) * 100}%`,
                    top: "50%",
                    width: `${
                        ((rekognitionItem.endTimestamp - rekognitionItem.startTimestamp) / props.videoDuration) * 100
                    }%`,
                    marginTop: -12,
                    height: "80%",
                    backgroundColor: mapToColour(rekognitionItem),
                    zIndex: props.zIndex ?? 1
                }}
            ></div>
        );
    };

    return (
        <div
            className="container-div"
            style={{
                width: "100%",
                height,
                alignContent: "center",
                backgroundColor: "white",
                position: "relative",
                verticalAlign: "middle",
                objectPosition: "relative",
                border: "1px solid #d3d0d0",
                marginBottom: "0.5%"
            }}
            onClick={onClick}
        >
            {!isLoading && rekognitionItems.map(mapToRekognitionSegmentBar)}
        </div>
    );
};

const mapToColour = (item: RekognitionResultItem) => {
    if (item.type === "OpeningCredits") {
        return "#ea7158";
    }
    return "#ea7158";
};
